import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Beatport = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 20 25'
  >
    <path
      d='M20 17.756C20 21.782 16.792 25 12.782 25s-7.218-3.169-7.218-7.244c0-1.91.752-3.621 1.905-4.929l-4.913 4.93L0 15.14l5.514-5.483c.752-.755 1.153-1.71 1.153-2.817V0h3.609v6.891c0 2.113-.752 3.874-2.206 5.332l-.15.151a7.257 7.257 0 014.862-1.911c4.11.05 7.218 3.32 7.218 7.293zm-3.258 0c0-2.162-1.805-3.873-3.96-3.873-2.206 0-3.91 1.811-3.91 3.873 0 2.113 1.755 3.924 3.91 3.924 2.256 0 3.96-1.861 3.96-3.924z'
      fill={ color }
    />
  </svg>
);

Beatport.propTypes = { ...iconPropTypes };

Beatport.defaultProps = { ...iconDefaultProps };

export default Beatport;